import gql from 'graphql-tag';
import query from '../../../routes/site-admin/feeCategory/feeCategoryList/getAllFeeCategories.graphql';
import showToaster from '../../../helpers/showToaster';

const mutation = gql`
  mutation($id: Int!) {
    deleteFeeCategory(id: $id) {
      status
      errorMessage
    }
  }
`;

export function deleteFeeCategory(id) {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation,
        variables: { id },
        refetchQueries: [{ query }],
      });

      if (data && data.deleteFeeCategory && data.deleteFeeCategory.status === 200) {
        showToaster({ messageId: 'deleteFeeCategory', toasterType: 'success' });
        return { status: 200 };
      }
      const err =
        (data && data.deleteFeeCategory && data.deleteFeeCategory.errorMessage) ||
        'Could not deactivate fee category';
      showToaster({ messageId: 'feeCategoryError', toasterType: 'error', requestContent: err });
      return { status: 400, errorMessage: err };
    } catch (error) {
      showToaster({
        messageId: 'feeCategoryError',
        toasterType: 'error',
        requestContent: error && error.message,
      });
      return { status: 400, errorMessage: error && error.message };
    }
  };
}

export default deleteFeeCategory;
